import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchApiData } from "../../store/slicers/apiSlicer.js";
import AppLayout from "../layouts/AppLayout.jsx";
import DataStateWrapper from "../components/common/DataStateWrapper";

const ContentInformation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [informations, setinformations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem("onpr_language") || "fr";
  });

  const { data, isLoading, error } = useSelector((state) => ({
    data: state.apiData?.data?.informations,
    isLoading: state.apiData?.loading?.informations,
    error: state.apiData?.error?.informations,
  }));

  useEffect(() => {
    getinformations();
  }, []);

  useEffect(() => {
    if (data?.data) {
      setinformations(data.data);
    }
  }, [data]);

  const getinformations = (page = 1) => {
    dispatch(
      fetchApiData({
        url: `informations?page=${page}`,
        itemKey: "informations",
      })
    );
    setCurrentPage(page);
  };

  const handleLanguageChange = (lang) => {
    setCurrentLang(lang);
    localStorage.setItem("onpr_language", lang);
  };

  const handleInfoClick = (annonce) => {
    history.push(`/information/${annonce.id}`);
  };

  const getTitle = (annonce) => {
    return currentLang === "fr" ? annonce.title_fr : annonce.title_en;
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const getExcerpt = (info) => {
    const description =
      currentLang === "fr" ? info.description_fr : info.description_en;
    const text = stripHtml(description);
    return text.length > 200 ? text.substring(0, 200) + "..." : text;
  };

  return (
    <div className="info-list-container">
      <div className="info-header">
        <h2 className="section-title">informations ONPR</h2>
        {/* <LanguageToggle currentLang={currentLang} onLanguageChange={handleLanguageChange} /> */}
      </div>

      <DataStateWrapper
        isLoading={isLoading}
        error={error}
        onRetry={() => getinformations(currentPage)}
        skeletonType="card"
        skeletonCount={6}
      >
        {informations.length === 0 ? (
          <div className="no-data-placeholder">
            <i
              className="pi pi-inbox"
              style={{ fontSize: "4rem", color: "#ccc" }}
            ></i>
            <p>Aucune annonce disponible</p>
          </div>
        ) : (
          <>
            <div className="info-grid">
              {informations.map((annonce) => (
                <div
                  key={annonce.id}
                  className="info-card"
                  onClick={() => handleInfoClick(annonce)}
                >
                  <div className="info-icon">
                    <i className="pi pi-info-circle"></i>
                  </div>
                  <div className="info-content">
                    <h3 className="info-title">{getTitle(annonce)}</h3>
                    <p className="info-excerpt">{getExcerpt(annonce)}</p>
                    <span className="info-date">
                      <i className="pi pi-calendar"></i>{" "}
                      {new Date(annonce.created_at).toLocaleDateString("fr-FR")}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {data?.last_page > 1 && (
              <div className="pagination">
                <button
                  onClick={() => getinformations(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="pagination-btn"
                >
                  <i className="pi pi-angle-left"></i> Précédent
                </button>
                <span className="pagination-info">
                  Page {currentPage} sur {data.last_page}
                </span>
                <button
                  onClick={() => getinformations(currentPage + 1)}
                  disabled={currentPage === data.last_page}
                  className="pagination-btn"
                >
                  Suivant <i className="pi pi-angle-right"></i>
                </button>
              </div>
            )}
          </>
        )}
      </DataStateWrapper>

      <style jsx>{`
        .info-list-container {
          max-width: 1200px;
          margin: 30px auto;
          padding: 0 20px;
        }
        .info-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }
        .section-title {
          color: #00a652;
          font-size: 1.8rem;
          margin: 0;
          padding-bottom: 15px;
          border-bottom: 4px solid #d32f2f;
          position: relative;
        }
        .section-title::before {
          content: "";
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100px;
          height: 4px;
          background: #00a652;
        }
        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 25px;
        }
        .info-card {
          background: white;
          border-radius: 12px;
          padding: 25px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          transition: all 0.3s;
          border-left: 5px solid #00a652;
          cursor: pointer;
          display: flex;
          gap: 20px;
        }
        .info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
          border-left-color: #d32f2f;
        }
        .info-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #00a652 0%, #2d8659 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .info-icon i {
          font-size: 1.8rem;
          color: white;
        }
        .info-content {
          flex: 1;
        }
        .info-title {
          color: #00a652;
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: 1.4;
        }
        .info-excerpt {
          text-align: left;
          color: #666;
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 12px;
        }
        .info-date {
          color: #d32f2f;
          font-size: 0.85rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 5px;
        }
        .no-data-placeholder {
          text-align: center;
          padding: 60px 20px;
        }
        .no-data-placeholder p {
          color: #999;
          font-size: 1.1rem;
          margin-top: 15px;
        }
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          margin-top: 30px;
          padding: 20px;
        }
        .pagination-btn {
          background: #00a652;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s;
          font-weight: 600;
        }
        .pagination-btn:hover:not(:disabled) {
          background: #d32f2f;
          transform: translateY(-2px);
        }
        .pagination-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
          opacity: 0.6;
        }
        .pagination-info {
          color: #00a652;
          font-weight: 600;
        }
        @media (max-width: 768px) {
          .info-grid {
            grid-template-columns: 1fr;
          }
          .info-header {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </div>
  );
};

const informationsList = () => {
  return (
    <>
      <AppLayout>
        <ContentInformation />
      </AppLayout>
    </>
  );
};

export default informationsList;
